document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.querySelector('.footer-popular-links-toggle-btn');

  if (toggleButton) {
    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      const newExpandedState = !isExpanded;
      toggleButton.setAttribute('aria-expanded', newExpandedState);

      // Find the next sibling that is the toggleable item
      const parentLi = toggleButton.closest('.footer-popular-links-title-wrapper');
      if (parentLi) {
        const nextItem = parentLi.nextElementSibling;
        if (nextItem && nextItem.classList.contains('is-toggleable')) {
          nextItem.classList.toggle('is-open', newExpandedState);
          
          if (newExpandedState) {
            // Scroll the title wrapper to the top of the viewport
            setTimeout(() => {
              parentLi.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300); // Wait for the transition to complete for better scroll target accuracy
          }
        }
      }
    });
  }
});